import { render, staticRenderFns } from "./UtxoAddresses.vue?vue&type=template&id=26f61615&scoped=true&"
import script from "./UtxoAddresses.vue?vue&type=script&lang=ts&"
export * from "./UtxoAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f61615",
  null
  
)

export default component.exports